var map = {
	"./AIBadge.svg": 80513,
	"./AIBadgeWhite.svg": 37135,
	"./Archive.svg": 49364,
	"./Archive2.svg": 31212,
	"./Arm.svg": 99452,
	"./Arrow.svg": 1985,
	"./Arrow1.svg": 63200,
	"./ArrowBack.svg": 72710,
	"./Attention.svg": 27394,
	"./AuthBackgroundImage.svg": 67887,
	"./AuthCarouselBackground.svg": 62290,
	"./AvatarFiller.svg": 1340,
	"./BadConnection.svg": 48312,
	"./Bell.svg": 69655,
	"./Book.svg": 33619,
	"./Britain-flag.svg": 12044,
	"./Bullet.svg": 43261,
	"./CameraOrange.svg": 38921,
	"./CameraPurple.svg": 32515,
	"./CameraYellow.svg": 43912,
	"./Check.svg": 56051,
	"./CheckGreen.svg": 68326,
	"./CheckedIcon.svg": 63225,
	"./Checkmark.svg": 48958,
	"./Chevron.svg": 76978,
	"./Chevron2.svg": 24451,
	"./ChevronSmall.svg": 84488,
	"./Circle.svg": 70795,
	"./CloseIcon.svg": 98945,
	"./Comment.svg": 35832,
	"./ContactUs.svg": 71030,
	"./CopyIcon.svg": 78091,
	"./CopyLink.svg": 57901,
	"./Cross.svg": 95627,
	"./DashboardTip.svg": 21031,
	"./Document.svg": 89496,
	"./Documents.svg": 41634,
	"./DocumentsIcon.svg": 91447,
	"./DownArrow.png": 68300,
	"./DownloadImage.svg": 19010,
	"./DropDown-Archive.svg": 86494,
	"./Duplicate.svg": 91466,
	"./Eye.svg": 58310,
	"./Favourite.svg": 13513,
	"./Feedback.svg": 53087,
	"./Filter.svg": 15856,
	"./Gallery.svg": 66023,
	"./German-flag.svg": 13527,
	"./Google.svg": 70319,
	"./Hand.svg": 79681,
	"./Handover.svg": 65218,
	"./Home.svg": 23413,
	"./HomePlus.svg": 81264,
	"./IconFacebook.svg": 10098,
	"./IconLink.svg": 94210,
	"./IconLinkedIn.svg": 80343,
	"./IconTwitter.svg": 13485,
	"./IconXing.svg": 68219,
	"./LabelPro.svg": 34967,
	"./Left.svg": 79971,
	"./LightBulb.svg": 32427,
	"./Line.svg": 19475,
	"./Loading.svg": 13204,
	"./LogOut.svg": 45650,
	"./Logo.svg": 64874,
	"./LogoSad.svg": 11672,
	"./Minus.svg": 12740,
	"./MobileFallback.svg": 92414,
	"./NavHome.svg": 6879,
	"./NavLogout.svg": 66523,
	"./NavProfile.svg": 37141,
	"./NavSubscription.svg": 1841,
	"./NavWorkspace.svg": 98166,
	"./NoAccess.svg": 38623,
	"./NotificationBell.svg": 18826,
	"./Offboarding.svg": 28097,
	"./Onboarding.svg": 51256,
	"./Oops.svg": 63617,
	"./OpenFile.svg": 85931,
	"./OpenInNewTab.svg": 24588,
	"./PaginationLeft.svg": 36924,
	"./PaginationRight.svg": 43057,
	"./Pencil.svg": 67059,
	"./Person.svg": 43006,
	"./Pixel.svg": 41958,
	"./Play.svg": 17819,
	"./Plus.svg": 29171,
	"./Plus2.svg": 37158,
	"./PlusIcon.svg": 57575,
	"./Polygon.svg": 77194,
	"./ProfileCheck.svg": 87130,
	"./ProfileDelete.svg": 62069,
	"./ProfilePasswordKey.svg": 91705,
	"./Read.svg": 39,
	"./Record.svg": 66197,
	"./Reporting.svg": 33199,
	"./Rocket.svg": 48509,
	"./Search.svg": 13586,
	"./SelectArrow.svg": 86548,
	"./Settings.svg": 18652,
	"./ShareBack.svg": 88254,
	"./ShareCollaborator.svg": 22703,
	"./ShareDelete.svg": 51437,
	"./ShareDropdown.svg": 87598,
	"./ShareLock.svg": 19478,
	"./SharePlus.svg": 80867,
	"./ShareTogle.svg": 15000,
	"./ShareViewers.svg": 46145,
	"./ShowLess.svg": 60238,
	"./ShowMore.svg": 62345,
	"./SmallArrow.svg": 70078,
	"./Smile.svg": 62438,
	"./Square.svg": 29498,
	"./Star.svg": 23974,
	"./StatsClock.svg": 56737,
	"./StepComplete.svg": 26044,
	"./Stop.svg": 4362,
	"./Text.svg": 12677,
	"./Themi.svg": 78031,
	"./ThemiAi.svg": 21472,
	"./ThemiLogo.svg": 98926,
	"./ThemiLogoWhite.svg": 91545,
	"./ThemiLogoWhiteSmall.svg": 25442,
	"./Themis.svg": 1507,
	"./ThemisLogo.svg": 48026,
	"./ThreeDots.svg": 63767,
	"./Tools.svg": 73611,
	"./Trash.svg": 13829,
	"./TryPro.svg": 50069,
	"./User.svg": 77083,
	"./ViewingMode.svg": 49348,
	"./Views.svg": 58051,
	"./Warning.svg": 75670,
	"./button-arrow.svg": 99186,
	"./linkedin.svg": 78500,
	"./mail.svg": 41661,
	"./temp.svg": 71786,
	"./twitter.svg": 83961,
	"./whatsapp.svg": 3881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;